import React from "react";
import { Container } from "react-bootstrap";
import "./promo.css";

const Promo = () => {
  return (
    <Container className="bg-danger py-5 text-center" fluid>
      <h1 className="text-warning display-1 fw-bolder text-decoration-underline">
        Promo
      </h1>
      <div className="video-responsive">
        <iframe
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/6BCpIfT0OPI`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    </Container>
  );
};

export default Promo;
